<template>
  <!-- Timeout della sessione (pattern .settings-card): testa con Modifica; in
       lettura l'impostazione attuale come riga di lista, in modifica le due
       scelte, i minuti e le azioni -->
  <section class="shadowedCard p-4 settings-card">
    <div class="section-head mb-3">
      <b-icon icon="clock-history" class="section-head__icon" aria-hidden="true"></b-icon>
      <h2 class="section-title mb-0 mr-auto">{{ $t('SessionLengthSetter.timeout_sessione') }}</h2>
      <b-button
        v-if="!isEditing"
        type="button"
        variant="outline-secondary"
        size="sm"
        :aria-label="$t('SessionLengthSetter.modifica_timeout')"
        @click="isEditing = true"
      >
        {{ $t('AnagraficaComponent.modifica') }}
      </b-button>
    </div>
    <p class="settings-card__lead">{{ $t('SessionLengthSetter.descrizione') }}</p>

    <b-form @submit.prevent="submitNewValue" v-if="isEditing">
      <b-form-checkbox
        class="mb-2"
        v-model="isTimeoutAtLogout"
        name="localUserSessionTimeout"
        :readonly="!isEditing"
        :value="true"
      >
        {{ $t('SessionLengthSetter.sessione_logout') }}
      </b-form-checkbox>
      <b-form-checkbox
        v-model="isTimeoutAtLogout"
        name="localUserSessionTimeout"
        :value="false"
        :readonly="!isEditing"
      >
        {{ $t('SessionLengthSetter.sessione_scade') }}
      </b-form-checkbox>

      <b-input-group v-if="!isTimeoutAtLogout" class="mt-3">
        <b-form-input
          v-if="!isTimeoutAtLogout"
          type="number"
          min="5"
          max="60"
          v-model="localUserSessionTimeout"
          :readonly="!isEditing"
          class="border-top-right-radius-0 border-bottom-right-radius-0"
        ></b-form-input>
        <template #append>
          <b-input-group-text>{{ $t('SessionLengthSetter.minuti_inattivita') }}</b-input-group-text>
        </template>
      </b-input-group>

      <div class="form-actions form-actions--end mt-4">
        <b-button
          type="button"
          variant="outline-secondary"
          size="sm"
          @click="handleAnnulla()"
          >{{ $t('SessionLengthSetter.annulla') }}</b-button
        >
        <b-button type="submit" variant="secondary" size="sm"
          >{{ $t('SessionLengthSetter.salva_modifiche') }}
        </b-button>
      </div>
    </b-form>
    <div v-else class="list-stack">
      <div class="list-row">
        <span class="list-row__icon" aria-hidden="true">
          <b-icon :icon="isTimeoutAtLogout ? 'box-arrow-right' : 'hourglass-split'"></b-icon>
        </span>
        <div class="list-row__body">
          <p class="list-row__title mb-0">{{ timeoutState }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { userService } from "@/_services";

export default {
  name: "SessionLengthSetter",
  props: {
    userHash: {
      type: String,
      required: true,
    },
    userSessionTimeout: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isEditing: false,
      isTimeoutAtLogout: false,
      timeoutState: "",
      localUserSessionTimeout: 0,
    };
  },
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
    ...mapState("utente", ["status", "user"]),
  },
  watch: {
    isTimeoutAtLogout: function (val) {
      this.timeoutState = val
        ? this.$t('SessionLengthSetter.sessione_logout')
        : this.$t('SessionLengthSetter.sessione_scade');

      //   if (val) {
      //     // this.localUserSessionTimeout = 0
      //   } else {
      //     // this.localUserSessionTimeout = this.userSessionTimeout ?? 5
      //   }
    },
    userSessionTimeout: function (val) {
      this.localUserSessionTimeout = val;

      this.timeoutState =
        val === 0
          ? this.$t('SessionLengthSetter.sessione_logout')
          : `${this.$t('SessionLengthSetter.sessione_scade')} ${this.userSessionTimeout} ${this.$t('SessionLengthSetter.minuti_inattivita')}`;
    },
  },

  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    ...mapActions("utente", ["setAnagrafica", "me"]),
    handleAnnulla() {
      this.isEditing = false;
      this.localUserSessionTimeout = this.userSessionTimeout;
      this.isTimeoutAtLogout = this.userSessionTimeout === 0;
    },
    submitNewValue() {
      var self = this;
      userService
        .updateUser(this.userHash, {
          session_timeout_minutes: this.isTimeoutAtLogout
            ? 0
            : this.localUserSessionTimeout,
        })
        .then(function (res) {
          self.successAlert(self.$t('SessionLengthSetter.successo'));
          self.isEditing = false;
          self.me();
        })
        .catch(function (err) {
          self.errorAlert(self.$t('SessionLengthSetter.errore'));
        });
    },
  },
  created() {
    this.isTimeoutAtLogout = this.userSessionTimeout === 0;
    this.timeoutState = this.isTimeoutAtLogout
    ? this.$t('SessionLengthSetter.sessione_logout')
    : `${this.$t('SessionLengthSetter.sessione_scade')} ${this.userSessionTimeout}
    ${this.$t('SessionLengthSetter.minuti_inattivita')}`;
    this.localUserSessionTimeout = this.userSessionTimeout;
  },
  mounted() {},
};
</script>

